import { subDays, addDays } from 'date-fns';

/**
 * Substracts number of {days} from the provided {date}
 *
 * @example
 *   const minDate = createMinDate(new Date(), 5)
 *   <DatePicker minDate={minDate} />
 */ const createMinDate = (date, days)=>{
    return date instanceof Date && typeof days === 'number' ? subDays(date, days) : undefined;
};
/**
 * Add number of {days} to the provided {date}
 *
 * @example
 *   const maxDate = createMaxDate(new Date(), 10)
 *   <DatePicker maxDate={maxDate} />
 */ const createMaxDate = (date, days)=>{
    return date instanceof Date && typeof days === 'number' ? addDays(date, days) : undefined;
};

export { createMaxDate, createMinDate };
//# sourceMappingURL=create-dates.js.map
